import {
  checkUserHasAdminRole,
  checkUserHasManagerRole,
  checkUserHasMemberRole,
  getLandingRoute,
} from "app/services/app.state.service";
import { Navigate } from "react-router-dom";
import { KnowledgeAdminView } from "app/components/knowledge/KnowledgeAdminView";
import { KnowledgeManagerView } from "app/components/knowledge/KnowledgeManagerView";
import { KnowledgeMemberView } from "app/components/knowledge/KnowledgeMemberView";

export const KnowledgeRouterFactory = () => {
  if (checkUserHasAdminRole()) {
    return <KnowledgeAdminView />;
  } else if (checkUserHasManagerRole()) {
    return <KnowledgeManagerView />;
  } else if (checkUserHasMemberRole()) {
    return <KnowledgeMemberView />;
  } else {
    // Not allowed here — route to the user's landing screen rather than
    // reloading the app, which would blank the screen on slower networks.
    return <Navigate to={getLandingRoute()} replace />;
  }
};

